import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const emailValidation = yup.object().shape({
    emails: yup.array().of(yup.string().email(ERRORS.email).required(ERRORS.required)),
});
